"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

var _utils = require("./utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
column for grid
*/
function Col(_ref) {
  var Component = _ref.componentEl,
      className = _ref.className,
      children = _ref.children,
      xs = _ref.xs,
      sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg,
      xsOffset = _ref.xsOffset,
      smOffset = _ref.smOffset,
      mdOffset = _ref.mdOffset,
      lgOffset = _ref.lgOffset,
      last = _ref.last,
      first = _ref.first;
  var cssClasses = ['st_col'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  if (xs && xs !== true) cssClasses.push("st_col-xs-" + xs);
  if (xs === true) cssClasses.push('st_col-xs');
  if (sm && sm !== true) cssClasses.push("st_col-sm-" + sm);
  if (sm === true) cssClasses.push('st_col-sm');
  if (md && md !== true) cssClasses.push("st_col-md-" + md);
  if (md === true) cssClasses.push('st_col-md');
  if (lg && lg !== true) cssClasses.push("st_col-lg-" + lg);
  if (lg === true) cssClasses.push('st_col-lg');
  if (xsOffset) cssClasses.push("st_col-xs-offset-" + xsOffset);
  if (smOffset) cssClasses.push("st_col-sm-offset-" + smOffset);
  if (mdOffset) cssClasses.push("st_col-md-offset-" + mdOffset);
  if (lgOffset) cssClasses.push("st_col-lg-offset-" + lgOffset);
  if (last) cssClasses.push("st_last-" + last);
  if (first) cssClasses.push("st_first-" + first);
  return /*#__PURE__*/_react["default"].createElement(Component, {
    className: cssClasses.join(' ')
  }, children);
}
/*
between
around
bottom
middle
top
center
start
end

xs sm md lg
*/


Col.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /* size at XS breakpoint */
  xs: _propTypes["default"].oneOf([true].concat(_utils.cols)),

  /* size at SM breakpoint */
  sm: _propTypes["default"].oneOf([true].concat(_utils.cols)),

  /* size at MD breakpoint */
  md: _propTypes["default"].oneOf([true].concat(_utils.cols)),

  /* size at LG breakpoint */
  lg: _propTypes["default"].oneOf([true].concat(_utils.cols)),

  /* offset at XS breakpoint */
  xsOffset: _propTypes["default"].oneOf(_utils.cols),

  /* offset at SM breakpoint */
  smOffset: _propTypes["default"].oneOf(_utils.cols),

  /* offset at MD breakpoint */
  mdOffset: _propTypes["default"].oneOf(_utils.cols),

  /* offset at LG breakpoint */
  lgOffset: _propTypes["default"].oneOf(_utils.cols),

  /* move item to be last */
  last: _propTypes["default"].oneOf(_utils.breakpoints),

  /* move item to be first */
  first: _propTypes["default"].oneOf(_utils.breakpoints)
};
Col.defaultProps = {
  componentEl: utils.componentEl.defaults,
  className: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xsOffset: null,
  smOffset: null,
  mdOffset: null,
  lgOffset: null,
  last: null,
  first: null
};
var _default = Col;
exports["default"] = _default;